import GroupedOption, { Option } from '@appsinti/ui-core/dropdown/interfaces/IGroupOption';
import Translation from '@appsinti/i18n/interfaces/Translation';
import IArea from '../interfaces/IArea';

export const getOptions = (areas: IArea[], translateObject: (translation: Translation) => string): GroupedOption[] => {
  return areas.map((area) => ({
    label: translateObject(area.name),
    options: area.cameras.map((camera) => ({
      label: translateObject(camera.locationName),
      value: camera.id,
      parentId: area.id,
    })),
  }));
};

export const getSelectedOptions = (options: GroupedOption[], previewIds: string[]): Option[] => {
  const optionsByValue = new Map<string, Option>();
  for (const optionsGroup of options) {
    for (const option of optionsGroup.options) {
      optionsByValue.set(option.value, option);
    }
  }

  return previewIds
    .map((id) => optionsByValue.get(id))
    .filter((option): option is Option => !!option);
};
